export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";